import React from 'react';

// GraphQl
import { useQuery } from '@apollo/react-hooks';

// Components & Others
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import LoadingIndicator from '../../../LoadingIndicator';
import MonthlyIncomeRangeForm from '../MonthlyIncomeRangeForm';
import { GET_MONTHLY_INCOME_RANGE } from '../queries';

function MonthlyIncomeRangeEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_MONTHLY_INCOME_RANGE, {
    variables: { id },
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    console.error(error);
    history.goBack();
  }

  const formatValue = { ...data.monthlyIncomeRange };
  if (!formatValue.minimum) formatValue.minimum = '';
  if (!formatValue.maximum) formatValue.maximum = '';
  if (!data.monthlyIncomeRange) {
    history.goBack();
  }

  return (
    <MonthlyIncomeRangeForm monthlyIncomeRange={formatValue} id={id} isEdit />
  );
}

MonthlyIncomeRangeEdit.propTypes = {};

export default MonthlyIncomeRangeEdit;
